module.exports = __webpack_public_path__ + "static/screenshot-editor-039f68eae8738003937cffc1f86fbe49.png";